import React, { Component, cloneElement } from "react";

import { Item, Button, Modal, Header, Input } from "semantic-ui-react";

import ApprovedReimbursementItem from "./ApprovedReimbursementItem";

import _ from "lodash";

import { payReimbursements } from "../actions/reimbursements";

class CheckPayForm extends Component {
  constructor() {
    super();

    this.state = {
      text_box: "",
    };
  }

  handleChange = event => {
    this.setState({
      text_box: event.target.value,
    });
  };

  render() {
    return (
      <Input
        onChange={this.handleChange}
        disabled={this.props.disabled}
        value={this.state.text_box}
        action={{
          primary: true,
          content: "Paid via check",
          onClick: () => this.props.onClick(this.state.text_box),
          disabled: this.props.disabled,
          loading: this.props.loading,
          icon: "university",
          labelPosition: "right",
        }}
        placeholder="Check # (optional)"
        icon="university"
        iconPosition="left"
      />
    );
  }
}

class PendingPersonModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      open: false
    };
  }

  open = () => {
    this.setState({
      open: true
    });
  };

  close = () => {
    this.setState({
      open: false
    });
  };

  submit = options => {
    this.setState({
      submitting: options.method
    });
    payReimbursements(this.props.person.pendingReimbursements, options)
      .catch(() => {
        this.setState({
          submitting: false
        });
      })
  };

  render() {
    const props = this.props;
    const person = props.person;
    const amountOwed = _.sumBy(person.pendingReimbursements, r => +r.amount);

    return (
      <Modal
        trigger={cloneElement(props.trigger, {
          onClick: this.open
        })}
        open={this.state.open}
        onClose={this.close}
        closeIcon={true}
        centered={false}
      >
        <Modal.Header>{person.name}</Modal.Header>
        <Modal.Content scrolling>
          <Header dividing>Reimbursements pending payment</Header>
          <Item.Group>
            {person.pendingReimbursements.map((r, i) => (
              <ApprovedReimbursementItem reimbursement={r} key={i} />
            ))}
          </Item.Group>
        </Modal.Content>
        <Modal.Actions>
          <Header
            style={{
              float: "left",
              textAlign: "left",
              marginTop: "0.35em",
              marginBottom: "1em"
            }}
          >
            Total Owed: ${amountOwed.toFixed(2)}
          </Header>
          <CheckPayForm
            disabled={!!this.state.submitting}
            loading={this.state.submitting === 'check'}
            onClick={(check_number) => this.submit({ method: 'check', check_number })}
          />
          <Button
            labelPosition="right"
            icon="dollar sign"
            content="Paid via cash"
            positive
            disabled={!!this.state.submitting}
            loading={this.state.submitting === 'cash'}
            onClick={() => this.submit({ method: 'cash' })}
            style={{ height: '2.7em' }}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default PendingPersonModal;



// WEBPACK FOOTER //
// ./frontend/src/components/PendingPersonModal.js